<template lang="pug">
    .z-task-time(v-loader-overlay="progress" v-if="$props.taskId && $props.userId && $props.user")
        //.z-task-time__add-btn.toggle-btn(v-on:click="toggleTimeline")
            span {{ (show) ? 'Скрыть время' : 'Показать время' }}
            md-icon.small keyboard_arrow_down

        .z-task-time__body(v-show="show")
            .z-task-time__list
                .z-time__item(v-for="(item, i) in timeline" v-bind:class="{'active': item.active}")
                    .z-time__head(v-if="item.user")
                        .z-time__user {{ (item.user.fio) ? item.user.fio : item.user.login }}
                    .z-time__top
                        .z-time__field.date(v-bind:class="{'active': item.active}")
                            .z-time-input(v-bind:class="{'active': item.active}")
                                datetime(
                                    v-bind:id="('time-date-' + i)"
                                    v-bind:name="('time-date-' + i)"
                                    v-validate="'required'"
                                    v-model="item.date"
                                    input-class=""
                                    type="date"
                                    v-bind:use12-hour="false"
                                    v-bind:week-start="1"
                                    v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }"
                                    v-bind:disabled="!item.active"
                                )
                        .z-time__field.time(v-bind:class="{'active': item.active}")
                            .z-time-input(v-bind:class="{'active': item.active}")
                                input(type="number" v-model="item.days" v-bind:disabled="!item.active" min="0" max="365" placeholder="0")
                                label д
                            .z-time-input(v-bind:class="{'active': item.active}")
                                input(type="number" v-model="item.hours" v-bind:disabled="!item.active" min="0" max="999" placeholder="0")
                                label ч
                            .z-time-input(v-bind:class="{'active': item.active}")
                                input(type="number" v-model="item.minutes" v-bind:disabled="!item.active" min="0" max="60" placeholder="0")
                                label м

                        .z-time__field.title(v-bind:class="{'active': item.active}") 1д = 8ч = 480м

                        .z-time__field.action-bar(v-if="parseInt(item.user.id) === parseInt($props.user.id)")
                            .z-time__btn(v-if="!item.active" v-on:click="activate(i)")
                                md-icon.small edit

                            .z-time__btn(v-if="item.active" v-on:click="showDeleteDialog(item, i)")
                                md-icon.small delete

                            .z-time__btn(v-if="item.active" v-on:click="saveTime(item, i)")
                                md-icon.small check

                            .z-time__btn(v-if="item.active" v-on:click="deactivate(i)")
                                md-icon.small close

                    .z-time__bottom
                        .z-time__field.description(v-bind:class="{'active': item.active}")
                            .z-time__description-content(v-show="!item.active" v-html="item.description")
                            .z-time-input(v-show="item.active" v-bind:class="{'active': item.active}")                        
                                textarea(v-bind:ref="('desc-' + i)" v-model="item.description" minlength="0" maxlength="5000" v-on:input="resizeTextarea(('desc-' + i))" v-on:change="resizeTextarea(('desc-' + i))" v-on:paste="resizeTextarea(('desc-' + i))")
                            
            .z-task-time__add-btn(v-on:click="addItem")
                span Добавить
                md-icon.small add

        md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
            md-dialog-title {{ 'Удалить учтёное время' + ((timeToDelete) ? (' за ' + moment(timeToDelete.date).format('DD.MM.YYYY')) : '') + '?' }}
            md-dialog-actions
                md-button.md-primary(@click="hideDeleteDialog()") Отмена
                md-button.md-primary(@click="removeTime()") Удалить
</template>
<script>
    export default {
        name: 'z-task-time',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-task-time'
            },
            name: {
                type: String,
                default: 'z-task-time'
            },
            label: {
                type: String,
                default: ''
            },
            taskId: {
                type: Number,
                default: null
            },
            userId: {
                type: Number,
                default: null
            },
            user: {
                type: Object,
                default: () => {
                    return {
                        id:    null,
                        login: null,
                        email: null,
                        fio:   null,
                    }
                }
            }          
        },
        data() {
            return {
                timeline: [],
                show: true,
                loadKey: 'load-task-timeline-card',
                deleteDialog: false,
                timeToDelete: null,
                indexToDelete: null
            }
        },
        created() {
            this.init();
        },
        watch: {},
        computed: {
            progressObj() {
                return this.$store.state.progressObj;
            },
            progress() {
                return this.progressObj[this.loadKey];
            },
        },
        methods: {
            init() {
                this.$nextTick(() => this.getTimeline());
            },
            toggleTimeline() {
                this.show = !this.show;
            },
            activate(i) {
                this.timeline[i]['active'] = true;
                this.$nextTick(() => {
                    this.resizeTextarea(('desc-' + i));
                })
            },
            deactivate(i) {
                this.timeline[i]['active'] = false;
            },
            addItem() {
                let newTime = {
                    id:          null,
                    waste_time:  null,
                    task_id:     this.$props.taskId,
                    user_id:     this.$props.user.id,
                    date:        this.moment().format('YYYY-MM-DDT00:00:00.000Z'),
                    description: null,
                    user:    Object.assign({}, this.$props.user),
                    active:  true,
                    minutes: null,
                    hours:   null,
                    days:    null
                };
                this.timeline.push(Object.assign({}, newTime));
            },
            saveTime(item, i) {
                let url = (item.id) ? 'tasks/putTime' : 'tasks/postTime';

                let wasteTime = parseInt(item.hours * 60) + parseInt(item.days * 8 * 60) + parseInt(item.minutes);

                let data = {
                    waste_time:  parseInt(item.hours * 60) + parseInt(item.days * 8 * 60) + parseInt(item.minutes),
                    task_id:     this.$props.taskId,
                    user_id:     this.$props.user.id,
                    date:        this.moment(item.date).format('YYYY-MM-DD'),
                    description: item.description
                };
                if (item.id) data.id = item.id;

                this.$store.commit('showProgressBar', this.loadKey);
                this.$store.dispatch(url, data).then(r => {
                    this.timeline[i] = Object.assign({}, this.prepareTimeItem(r));
                    this.init();
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            removeTime() {
                if (!this.timeToDelete.id) this.timeline.splice(this.indexToDelete, 1);
                else {
                    this.$store.commit('showProgressBar', this.loadKey);
                    this.$store.dispatch('tasks/removeTime', this.timeToDelete.id).then(r => {
                        this.timeline.splice(this.indexToDelete, 1);
                        this.init();
                    }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
                }
                this.hideDeleteDialog();
            },
            showDeleteDialog(item, i) {
                this.indexToDelete = i;
                this.timeToDelete = Object.assign({}, item);
                this.deleteDialog = true;
            },
            hideDeleteDialog() {
                this.timeToDelete = Object.assign({}, {});
                this.deleteDialog = false;
                this.indexToDelete = null;
            },
            resizeTextarea(ref) {
                let desc = null;
                if (this.$refs[ref] instanceof Array) desc = this.$refs[ref][0];
                else desc = this.$refs[ref];
                if (desc) {
                    desc.style.height = 'auto';
                    desc.style.height = desc.scrollHeight+'px';
                }
            },
            getTimeline() {
                if (!this.$props.taskId) return;
                this.$store.commit('showProgressBar', this.loadKey);
                this.$store.dispatch('tasks/getTimelineByTaskId', this.$props.taskId).then(r => {
                    if (r && r.length) this.timeline = Object.assign([], r.map(item => {
                        item = this.prepareTimeItem(item);
                        return item;
                    }));
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            prepareTimeItem(item) {
                item.active  = false;
                item.minutes = Math.floor(item.waste_time);
                item.hours   = Math.floor(item.minutes/60);
                item.days    = Math.floor(item.hours/8);
                item.hours   = item.hours   - (item.days * 8);
                item.minutes = item.minutes - (item.hours * 60) - (item.days * 8 * 60);

                return item;
            }
        }
    }
</script>
<style lang="sass">
    .z-task-time
        display: flex
        flex-direction: column
        align-items: flex-start
        .z-time__btn
            display: flex
            align-items: center
            justify-content: center
            width: 26px
            height: 26px
            border-radius: 100%
            &:hover, &.active
                background: #e4e4e4
        .z-task-time__add-btn
            display: flex
            align-items: center
            justify-content: center
            font-size: 12px
            cursor: pointer
            transition: 0.1s
            height: 26px
            border-radius: 3px
            padding: 0 0px 0 6px
            .md-icon
                margin: 0 0 0 4px
            &:hover
                background: #e4e4e4
            &.toggle-btn
                margin: 0 0 5px 0
    .z-time__head
        padding: 0 5px
        .z-time__user
            font-size: 12px
            line-height: 12px
            color: #757575
    .z-task-time__body
        width: 100%
        display: flex
        flex-direction: column
        align-items: flex-start
    .z-task-time__list
        width: 100%
        margin: 0 0 10px 0
        .z-time__item
            padding: 4px 6px
            border-radius: 3px
            &:after
                content: ''
                display: block
                background: #d6d6d6
                width: 100%
                height: 1px
                margin: 0 auto
                opacity: 1
            &:hover, &.active
                background: #eee
                &:after
                    opacity: 0
        .z-time__top
            display: flex
            align-items: flex-start
            justify-content: flex-start
        .z-time__bottom
        .z-time-input
            input, textarea
                -webkit-appearance: none !important
                outline: none !important
                background: transparent
                font-size: 14px
                line-height: 16px
                border-radius: 3px
                padding: 4px
                border: 1px solid transparent
                box-sizing: border-box
                transition: 0.2s
                font-weight: normal
                height: 26px
                resize: none
                overflow: hidden
                &::-webkit-outer-spin-button, &::-webkit-inner-spin-button 
                    display: none
                    -webkit-appearance: none
                    margin: 0
            label
            textarea
                width: 100%
        .z-time-input.active
            input, textarea
                background: #e0e0e0
                border-color: #d4d4d4
                background: #fff
                border-color: #d4d4d4
            label

        .z-time__field.date
            flex-shrink: 0
            .z-time-input
                margin-right: 4px
                input
                    width: 105px
                label
        .z-time__field.time
            flex-shrink: 0
            display: flex
            align-items: center
            justify-content: flex-start
            .z-time-input
                margin-right: 4px
                input
                    width: 40px
                    margin-right: 4px
                    text-align: right
                label
        .z-time__field.title
            display: none
            height: 26px
            align-items: center
            justify-content: center
            color: #888888
            padding: 4px
            margin: 0 0 0 10px
            &.active
                display: flex
        .z-time__field.description
            width: 100%
            &.active
                margin: 4px 0 0 0
            .z-time__description-content
                padding: 0 5px
        .z-time__field.action-bar
            display: flex
            align-items: center
            justify-content: flex-start
            margin: 0 0 auto auto
            flex-shrink: 0
            .z-time__btn
                
</style>


// WEBPACK FOOTER //
// ZTaskTime.vue?e4a5c07c